import { Component, Inject, OnInit, ViewChild } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatPaginator } from '@angular/material/paginator'
import { MatTableDataSource } from '@angular/material/table'
import { ReviewsInsightsGuestSentiment } from '@tokeet-frontend/reviews'

@Component({
  selector: 'app-review-insights-guest-sentiments-dialog',
  templateUrl: './review-insights-guest-sentiments-dialog.component.html',
  styleUrls: ['./review-insights-guest-sentiments-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class ReviewInsightsGuestSentimentsDialogComponent implements OnInit {
  @ViewChild('paginator') set paginator(p: MatPaginator) {
    this.dataSource.paginator = p
  }

  dataSource = new MatTableDataSource<any>()
  displayedColumns = ['guest', 'date', 'rental', 'summary']

  constructor(
    public dialogRef: MatDialogRef<ReviewInsightsGuestSentimentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { items: ReviewsInsightsGuestSentiment[] }
  ) {}

  ngOnInit() {
    this.dataSource.data = this.data.items || []
  }

  close() {
    this.dialogRef.close()
  }
}
